import {
  decodeToken,
  useAuthenticatedUser,
} from "../components/Auth/AuthContext";

// Regular identities (user/site_owner) carry is_viewer on the token exposed
// via useAuthenticatedUser. /admin sits outside the AuthenticationGuard and
// keeps its own token under "admin-token", so it's checked separately.
export const useIsViewer = (): boolean => {
  const user = useAuthenticatedUser();
  if (user && "is_viewer" in user && user.is_viewer) {
    return true;
  }
  const adminToken = localStorage.getItem("admin-token");
  return adminToken ? Boolean(decodeToken(adminToken)?.is_viewer) : false;
};
